import _extends from "@babel/runtime/helpers/esm/extends";
import { useAxiosClient } from '../hooks';
import { createQueryKey, sanitizeParams } from '../utils';
import useQuery from './useQuery';
export default function useCount(variant, basePath, params, options) {
  const axiosClient = useAxiosClient();
  const paramsSanitized = sanitizeParams(_extends({}, variant === 'v2/{basePath}' && {
    _select: '_id'
  }, params));
  async function queryFn() {
    var _response$data;
    const url = variant.replace('{basePath}', basePath);
    const response = await axiosClient.get(url, {
      params: paramsSanitized
    });
    const data = ((_response$data = response.data) == null ? void 0 : _response$data.response) || response.data || [];
    return (data == null ? void 0 : data.length) || 0;
  }
  const queryKey = createQueryKey(basePath, variant, paramsSanitized);
  return useQuery(queryKey, queryFn, options);
}